import { render, staticRenderFns } from "./notify-card.vue?vue&type=template&id=61cbc9a3&scoped=true"
import script from "./notify-card.vue?vue&type=script&lang=js"
export * from "./notify-card.vue?vue&type=script&lang=js"
import style0 from "./notify-card.vue?vue&type=style&index=0&id=61cbc9a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cbc9a3",
  null
  
)

export default component.exports